"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneUtenteDtoToJSON = exports.CertificazioneUtenteDtoFromJSONTyped = exports.CertificazioneUtenteDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioneUtenteDtoFromJSON(json) {
    return CertificazioneUtenteDtoFromJSONTyped(json, false);
}
exports.CertificazioneUtenteDtoFromJSON = CertificazioneUtenteDtoFromJSON;
function CertificazioneUtenteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nominativo': !runtime_1.exists(json, 'nominativo') ? undefined : json['nominativo'],
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'modalitaCertificazioneDesc': !runtime_1.exists(json, 'modalitaCertificazioneDesc') ? undefined : json['modalitaCertificazioneDesc'],
        'statoCertificazioneDesc': !runtime_1.exists(json, 'statoCertificazioneDesc') ? undefined : json['statoCertificazioneDesc'],
        'emailCertificazione': !runtime_1.exists(json, 'emailCertificazione') ? undefined : json['emailCertificazione'],
        'cellulareCertificazione': !runtime_1.exists(json, 'cellulareCertificazione') ? undefined : json['cellulareCertificazione'],
        'emailCertificazioneMascherato': !runtime_1.exists(json, 'emailCertificazioneMascherato') ? undefined : json['emailCertificazioneMascherato'],
        'cellulareCertificazioneMascherato': !runtime_1.exists(json, 'cellulareCertificazioneMascherato') ? undefined : json['cellulareCertificazioneMascherato'],
        'motivazioneRichiestaCertificazione': !runtime_1.exists(json, 'motivazioneRichiestaCertificazione') ? undefined : json['motivazioneRichiestaCertificazione'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'dataUltimaModifica': !runtime_1.exists(json, 'dataUltimaModifica') ? undefined : (new Date(json['dataUltimaModifica'])),
    };
}
exports.CertificazioneUtenteDtoFromJSONTyped = CertificazioneUtenteDtoFromJSONTyped;
function CertificazioneUtenteDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nominativo': value.nominativo,
        'ndg': value.ndg,
        'modalitaCertificazioneDesc': value.modalitaCertificazioneDesc,
        'statoCertificazioneDesc': value.statoCertificazioneDesc,
        'emailCertificazione': value.emailCertificazione,
        'cellulareCertificazione': value.cellulareCertificazione,
        'emailCertificazioneMascherato': value.emailCertificazioneMascherato,
        'cellulareCertificazioneMascherato': value.cellulareCertificazioneMascherato,
        'motivazioneRichiestaCertificazione': value.motivazioneRichiestaCertificazione,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'dataUltimaModifica': value.dataUltimaModifica === undefined ? undefined : (value.dataUltimaModifica.toISOString()),
    };
}
exports.CertificazioneUtenteDtoToJSON = CertificazioneUtenteDtoToJSON;
